export const getParams = (key = "") => {
    const url = window.location.search;
    let match = url.match('[?&]' + key + '=([^&]+)');
    return match ? match[1] : null;
}